<template>
  <section aria-label="Unser Song" class="flex flex-col gap-3">
    <h2 class="font-display text-[22px] font-extrabold sm:text-[26px]">Unser Song</h2>

    <template v-if="consent">
      <iframe
        class="h-[80px] w-full rounded-xl sm:h-[152px] sm:rounded-3xl"
        src="https://open.spotify.com/embed/track/09hz0FYWSWZ4fOQGR8jogT?utm_source=generator&theme=0"
        frameborder="0"
        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        loading="lazy"
        title="Saufen bei Petra – Drunken Hippos auf Spotify"
      ></iframe>
      <button
        type="button"
        @click="revoke"
        class="self-start text-xs text-slate-400 underline underline-offset-2 transition-colors hover:text-white"
      >
        Spotify-Player wieder deaktivieren
      </button>
    </template>

    <!-- Ohne Zustimmung darf keine Verbindung zu Spotify aufgebaut werden -->
    <div
      v-else
      class="flex flex-col gap-3 rounded-xl border border-edge bg-panel p-4 sm:min-h-[152px] sm:justify-center sm:rounded-3xl sm:p-6"
    >
      <p class="text-sm text-slate-300">
        Beim Laden des Players wird eine Verbindung zu Spotify aufgebaut und Daten wie deine IP-Adresse werden an
        Spotify übertragen. Mehr dazu im
        <RouterLink to="/impressum#datenschutz" class="underline underline-offset-2 hover:text-white">Datenschutz</RouterLink>.
      </p>
      <button
        type="button"
        @click="grant"
        class="min-h-11 self-start rounded-xl bg-beer px-4 py-2 text-sm font-semibold text-night transition-opacity hover:opacity-90"
      >
        Spotify-Player laden
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useSpotifyConsent } from '@/composables/useSpotifyConsent';

const { consent, grant, revoke } = useSpotifyConsent();
</script>
